import { render, staticRenderFns } from "./RepresentativePrices.vue?vue&type=template&id=48af3040&"
import script from "./RepresentativePrices.vue?vue&type=script&lang=js&"
export * from "./RepresentativePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports